module.exports = __webpack_public_path__ + "img/stacked-line-chart.eed33056.svg";